import { render, staticRenderFns } from "./ExpiredComponent.vue?vue&type=template&id=0a197c66&"
import script from "./ExpiredComponent.vue?vue&type=script&lang=js&"
export * from "./ExpiredComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports